game.countMove = function() {
  "use strict";
  this.runtime.movesCount++;
};
